import axios from 'axios';
import * as firebase from 'firebase';
import _ from 'lodash';

import { BASE_URL } from './config';

export async function importProductsToFirebase({ token, data = null }){
  try {
    return await axios.post(`${BASE_URL}/importProductsFromCsv`, data, {
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}


//-- @deprecated --
export function getProductPageFromFirebase({ page = 1, limit = 10}){
  const startAtValue = ((page - 1) * limit) + 1;
  return new Promise((resolve, reject) => {
    firebase.database().ref().child('products').orderByChild('no').startAt(startAtValue).limitToFirst(limit).on('value', snapshot => {
      if (!snapshot.val()) {
        return reject("no more data");
      }
      const productList = [];

      snapshot.forEach((child) => {
        productList.push({ ...child.val(), key : child.key })
      })

      return resolve(productList);
    })
  })
}

export function getProductPageFromFirebaseNew(pages, limit = 10) {
  return new loadNewPage(pages, limit);
}

function loadNewPage(pages, pageSize = 10) {
  let query = firebase.database().ref().child('products').orderByChild('product_quantity').limitToLast(pageSize);
  const keys = Object.keys(pages); 
  if (keys.length > 0) {
    const quantity = (_.last(keys).split('___')[1] | 0) || null;
    query = query.endAt(quantity);
  } 
  return new Promise((resolve, reject) => {
    query.on("value", (snapshot) => {
      const entries = []
      snapshot.forEach((item) => {
        if (item.val().product_quantity === 0) { return }
        entries.push({ key: item.key, ...item.val()})
      })
      const isLastPage = entries.length < pageSize; 
      const firstItem = entries.splice(0, 1)[0];
      const key = !isLastPage ? firstItem.key + "___" + firstItem.product_quantity  : "__lastPage__";
      resolve({ key, items: entries.reverse() });
    })
  })
}

export async function addProductToFirebase({ data = {} }){
  try {
    const productData = {...data, product_name_lower: data.product_name.toLowerCase() };

    delete productData.product_code;
    const no = await incrementCount();
    await firebase.database().ref().child('products').child(data.product_code).set({ ...productData, no});

    return data.product_code;
  } catch (e) {
    throw e;
  }
}

function incrementCount(){
  return new Promise((resolve, reject) => {
    firebase.database().ref().child('product_count').once('value', count => {
      if (count.val()) {
        firebase.database().ref().child('product_count').set(count.val() + 1);
        return resolve(count.val() + 1);
      }
      firebase.database().ref().child('product_count').set(1);
      return resolve(1);
    })
  })
}

export async function updateProductTofirebase({ key = null, data = {} }){
  try {
    const productData = { ...data }
    if(productData.product_name) {
      productData.product_name_lower = productData.product_name.toLowerCase()
    }
    return await firebase.database().ref().child('products').child(key).update(productData);
  } catch (e) {
    throw e;
  }
}

// 
export async function deleteProductFromFirebase({ key = null}){
  try {
    // await updateAfterProductsNo(key);
    await firebase.database().ref().child('products').child(key).update({ product_quantity: 0 });
    return key;
  } catch (e) {
    throw e;
  }
}

export async function deleteAllProductsFromFirebase(token) {
  try {
    return await axios.delete(`${BASE_URL}/deleteAllProducts`, {
      headers: {
        'Authorization': token
      }
    })
  } catch (e) {
    throw e;
  }
}

// function updateAfterProductsNo(key){
//   const productRef = firebase.database().ref().child('products');
//   return new Promise((resolve, reject) => {
//     productRef.child(key).once('value', snapshot => {
//       if (snapshot.val()) {
//         productRef.orderByChild('no').startAt(snapshot.val().no).once('value', products => {
//           products.forEach(product => {
//             productRef.child(product.key).update({ no: product.val().no - 1 });
//           })

//           firebase.database().ref().child('product_count').once('value', count => {
//             firebase.database().ref().child('product_count').set(count.val() - 1);
//           })
//           resolve();
//         })
//       } else {
//         reject('product not found');
//       }
//     })
//   })
// }



// WEBPACK FOOTER //
// ./src/utils/productService.js